import { render } from "./_Modal-text.vue?vue&type=template&id=3e5cf63f&scoped=true"
import script from "./_Modal-text.vue?vue&type=script&lang=js"
export * from "./_Modal-text.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./_Modal-text.vue?vue&type=style&index=1&id=3e5cf63f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3e5cf63f"

export default script